import axiosInstance from "../../app/apiClient";
import { AuthPortal } from "../model/portal/auth";

const getOtp = (phoneNumber: string) =>
	axiosInstance.get(`/api/v1/auth/otp?phoneNumber=${phoneNumber}`);
const getToken = (phoneNumber: string, otp: string, ip: string) =>
	axiosInstance.get(
		`/api/v1/auth/getToken?phoneNumber=${phoneNumber}&otp=${otp}&deviceIp=${ip}`
	);
const getTokenSSO = (token: string) =>
	axiosInstance.get(`/api/v1/auth/v2/login-sso?access-code=${token}`);
const getLoginSSO = (username: string, password: string) =>
	axiosInstance.post("api/v1/auth/v2/login-sso", {
		username: username,
		password: password,
	});
const loginByHc = (phone: string) =>
	axiosInstance.post(`api/v1/auth/login-by-hc?phone=${phone}`);
const validateCasTicket = (ticket: string) =>
	axiosInstance.post("api/v1/auth/v2/login-sso", {
		ticket: ticket,
	});
const authPortal: AuthPortal = {
	getOtp,
	getToken,
	getTokenSSO,
	getLoginSSO,
	loginByHc,
	validateCasTicket,
};

export default authPortal;
